import React from "react";

import { search } from "lib/text";

import Card from "components/Card";
import SearchBar from "components/SearchBar";
import HelpItem from "components/app/help/HelpItem";

// structure: staticHelpContent.items[index].sections[index]
import staticHelpContent from "./staticHelpContent";
import "./HelpPage.css"


export default class HelpPage extends React.Component {
  
  static placeholder = (
    <div className="help-list__placeholder">
      <Card>
        <Card.Body>There are no help topics matching your search.</Card.Body>
      </Card>
    </div>
  );
  
  /**
   * Filter an array of help sections based on a search query
   *
   * @returns {Array} a new array containing only the sections that contain the query string in the header or body
   */
  static filterHelpSections(helpSections, query) {
    return helpSections.filter((helpSection) => {
      return search(helpSection.header, query) || search(helpSection.body, query);
    });
  }
  
  /**
   * Filter an array of help items based on a search query
   *
   * @returns {Array} a new array containing only the items that contain the query string in the title or sections
   */
  static filterHelpItems(helpItems, query) {
    return helpItems
      // First, filter the sections of each item
      .map((helpItem) => {
        // don't filter the sections if the item title matches the query!
        if (search(helpItem.title, query)) {
          return helpItem;
        }
        const sections = HelpPage.filterHelpSections(helpItem.sections, query);
        return { ...helpItem, sections };
      })
      // now filter out those items that have no matching sections
      .filter((helpItem) => {
        return helpItem.sections.length > 0;
      });
  }
  
  state = {
    helpItems: staticHelpContent.items,
    query: ""
  }

  onSearch = (query) => {
    this.setState({
      helpItems: HelpPage.filterHelpItems(staticHelpContent.items, query),
      query: query
    });
  }

  getHelpList = () => {
    return (
      <div className="help-list">
        { this.state.helpItems.map(item => (
          <HelpItem key={item.title} {...item} />
        )) }
      </div>
    )
  }

  render() {
    const hasItems = this.state.helpItems.length > 0;
    return (
      <div className="help-page">
        <div className="page-header">
          <h1 className="page-header__title">Help</h1>
          <hr />
        </div>
        <SearchBar onSearch={this.onSearch} query={this.state.query} />
        { hasItems ? this.getHelpList() : HelpPage.placeholder }
      </div>
    );

  }

}



// WEBPACK FOOTER //
// ./src/components/app/help/HelpPage.js